import axios from 'axios'
import configurations from './config.json'

export default axios.create({
    baseURL: process.env.NODE_ENV === "production" ? configurations.apiBaseEndpointProduction : configurations.apiBaseEndpointDevelopment,
    timeout: configurations.apiTimeout,
})

export const config = {
    api: {
        sendToken: '/sendToken',
        getChainConfigs: '/getChainConfigs',
        getBalance: '/getBalance',
        faucetAddress: 'faucetAddress'
    },
    // SITE_KEY: "6LeDy-8qAAAAAMCdJQ8P5FBIYvLWO7aLneMdKBG9",
    // V2_SITE_KEY: "6LeDy-8qAAAAAMCdJQ8P5FBIYvLWO7aLneMdKBG9",
    SITE_KEY: "6LeVSPMsAAAAAOMrQpQbyr7KBJSbHQy-oAVChRUM",
    V2_SITE_KEY: "6LeVSPMsAAAAAOMrQpQbyr7KBJSbHQy-oAVChRUM",
    ACTION: configurations.CAPTCHA.action,
    banner: configurations.banner
}
